import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { usePostHog } from 'posthog-js/react'

import { RootState } from '../store'

export const usePostHogIdentify = () => {
	const posthog = usePostHog()

	const { signed } = useSelector((state: RootState) => state.auth)
	const { id, email } = useSelector((state: RootState) => state.profile)

	const lastIdentified = useRef<{ id: string; email: string } | null>(null)

	useEffect(() => {
		if (!posthog) return

		const userIdentified =
			lastIdentified.current?.id === id &&
			lastIdentified.current?.email === email

		if (signed && id && email && !userIdentified) {
			posthog.identify(id, { email })
			lastIdentified.current = { id, email }

			return
		}

		posthog.reset()
		lastIdentified.current = null
	}, [signed, id, email, posthog])
}
